import type { CosmeticId, Progress } from "../progress/schema";

export const cosmeticIds: readonly CosmeticId[] = [
  "gloam",
  "lime",
  "coral",
  "indigo-tide",
  "jade-circuit",
  "constellation",
];

export const cosmeticCopy: Record<
  CosmeticId,
  {
    readonly name: string;
    readonly subtitle: string;
    readonly description: string;
    readonly condition: string;
  }
> = {
  gloam: {
    name: "暮界原型",
    subtitle: "GLOAM / 01",
    description: "穿过暮色的一束微光。温润的矿物绿，沿柔软的脊线缓缓流动。",
    condition: "默认拥有",
  },
  lime: {
    name: "极光信号",
    subtitle: "AURORA / 02",
    description: "青绿的躯体藏着明亮的脉冲，像一道游弋在夜色中的极光。",
    condition: "竞技单局存活 90 秒",
  },
  coral: {
    name: "珊瑚余烬",
    subtitle: "EMBER / 03",
    description: "珊瑚色外壳与细碎余烬，让每一次转身都留下一点温度。",
    condition: "完成第一局竞技",
  },
  "indigo-tide": {
    name: "靛蓝潮汐",
    subtitle: "TIDE / 04",
    description: "深靛色中泛起浅青涟漪，带着深海潮水般安静的力量。",
    condition: "竞技单局信号达到 750",
  },
  "jade-circuit": {
    name: "翡翠电路",
    subtitle: "CIRCUIT / 05",
    description: "黄铜线路嵌入翡翠，在流动的身躯上勾勒精密而轻巧的纹路。",
    condition: "竞技累计造成 3 次淘汰",
  },
  constellation: {
    name: "星图棱镜",
    subtitle: "PRISM / 06",
    description: "将一片星空披在身上。细小星点与棱镜光，沿着轨迹悄然铺开。",
    condition: "竞技造成一次淘汰",
  },
};

export function unlockProgress(
  id: CosmeticId,
  records: Progress["records"],
): { value: number; target: number; unit: string } {
  switch (id) {
    case "lime":
      return {
        value: Math.floor(records.longestSurvivalMs / 1000),
        target: 90,
        unit: "秒",
      };
    case "coral":
      return { value: records.matchesPlayed, target: 1, unit: "局" };
    case "indigo-tide":
      return { value: records.bestScore, target: 750, unit: "信号" };
    case "jade-circuit":
      return { value: records.eliminations, target: 3, unit: "次" };
    case "constellation":
      return { value: records.eliminations, target: 1, unit: "次" };
    default:
      return { value: 1, target: 1, unit: "" };
  }
}
